define.alias("shared/components/shared/media-item-modal", "settings/components/shared/media-item-modal");